import { Location } from '@angular/common';
import { Component, OnInit, Inject, inject } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { APIService, Contact } from 'src/app/API.service';
import { AuthService } from 'src/app/services/auth.service';
import { PhoneNumberUtil } from 'google-libphonenumber';
import { TuiCountryIsoCode } from '@taiga-ui/i18n';
import { CHAR_PLUS, TUI_IS_MOBILE } from '@taiga-ui/cdk';
import { TUI_COUNTRIES_MASKS } from '@taiga-ui/kit/tokens';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Auth } from 'aws-amplify';
import { TuiSelectModule } from '@taiga-ui/kit';

@Component({
  selector: 'app-new-contact',
  templateUrl: './new-contact.component.html',
})
export class NewContactComponent implements OnInit {
  
  _snackBar = inject(MatSnackBar);
  contactId = this.route.snapshot.params['id'];
  telephone = this.route.snapshot.params['telephone'];
  labelTelephone = this.route.snapshot.params['label'];
  createForm: FormGroup = this.fb.group({
    name: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.email]),
    telephone: new FormControl('', [
      Validators.required
    ]),
  });

  readonly countries = Object.values(TuiCountryIsoCode);
  countryIsoCode = TuiCountryIsoCode.ES;
  
  


  constructor(
    private fb: FormBuilder,
    private api: APIService,
    private authService: AuthService,
    private location: Location,
    private route: ActivatedRoute,
    @Inject(TUI_COUNTRIES_MASKS) private readonly countriesMasks: Record<TuiCountryIsoCode, string>,
  ) { }

  async ngOnInit() {
    try {
      await this.authService.refresh();
      await Auth.currentAuthenticatedUser();
      if (this.telephone && this.telephone.size > 4) {
        this.countryIsoCode = this.getCountryIsoCode(this.telephone);
        this.createForm.patchValue({
          telephone: this.telephone,
        });
      }

      if (this.contactId) {
        this.api.GetContact(this.contactId).then((data) => {
          this.createForm.patchValue(data);
          this.countryIsoCode = this.getCountryIsoCode(data.telephone);
        });
      } else if (this.telephone) {
        this.createForm.patchValue({
          telephone: this.telephone,
        });
      }
    } catch (error) {
      this.authService.logout();
    }
  }

  getCountryIsoCode(value: string) {
    const phoneUtil = PhoneNumberUtil.getInstance();
    const phoneNumber = phoneUtil.parse(CHAR_PLUS + value);
    const region = phoneUtil.getRegionCodeForNumber(phoneNumber);
    if (region !== undefined) {
      return TuiCountryIsoCode[region as TuiCountryIsoCode];
    }
    return TuiCountryIsoCode.ES;
  }

  async onCreate() {
    const contact: Contact = {
      ...this.createForm.getRawValue(),
      owner: this.authService.getUser().username ?? '',
    };

    const phoneUtil = PhoneNumberUtil.getInstance();
    const phoneNumber = phoneUtil.parse(contact.telephone);
    const region = phoneUtil.getRegionCodeForNumber(phoneNumber);
    if (!phoneUtil.isValidNumberForRegion(phoneNumber, region)) {
      this._snackBar.open("El teléfono introducido no es válido", 'Close');
      return
    }

    await this.api.CreateContact(contact).then(() => {
      this.goBack();
      this.createForm.reset();
    });
  }

  async onUpdate() {
    const contact: Contact = {
      ...this.createForm.getRawValue(),
      id: this.contactId,
    };

    const phoneUtil = PhoneNumberUtil.getInstance();
    const phoneNumber = phoneUtil.parse(contact.telephone);
    const region = phoneUtil.getRegionCodeForNumber(phoneNumber);
    if (!phoneUtil.isValidNumberForRegion(phoneNumber, region)) {
      this._snackBar.open("El teléfono introducido no es válido", 'Close');
      return
    }

    await this.api.UpdateContact(contact).then(() => {
      this.goBack();
      this.createForm.reset();
    });
  }

  goBack() {
    this.location.back();
  }
}
